import { render, staticRenderFns } from "./ManageTags.vue?vue&type=template&id=8ca0f0c8"
import script from "./ManageTags.vue?vue&type=script&lang=js"
export * from "./ManageTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports